import { MasterCategory, SubCategory } from '../../../categories';
import {AllCategoryTotals} from '../../index';

const getAllMasterCategoryBudgeted = (
	subCategoryAssignments: Map<MasterCategory['uuid'], Array<SubCategory['uuid']>>,
	categoryTotals: AllCategoryTotals
) => {
	return Array.from(subCategoryAssignments.entries()).reduce((acc, assignments) => {
		const [masterCatId, subCatIds] = assignments;
		acc.set(masterCatId, getMasterCategoryTotalBudgeted(subCatIds, categoryTotals));
		return acc;
	}, new Map());
};

export default getAllMasterCategoryBudgeted;

const getMasterCategoryTotalBudgeted = (
	subCatIds: Array<SubCategory['uuid']>,
	categoryTotals: AllCategoryTotals
) => {
	return subCatIds.reduce((acc, subCatId) => {
		return acc + (categoryTotals.categoryBudgeted.get(subCatId) || 0);
	}, 0);
};
